import { filters } from '@dh/bronson-react';
import React from 'react';
import { porscheThemeText } from '../../app.constants';
import { AppService } from '../../App.service';
import { PorscheButton } from '../../components';
import { LegalPopUp } from '../../components/Legal/popup';
import { hrefPreauthorization } from '../../config';
import { InitialConfiguration } from '../../interfaces';
import { ErrorUtilClass } from '../../utils/error.class';
import { VehicleModel } from '../../utils/interfaces';
import {
    carDataDoesNotMatch,
    changeOrSelectedErrorSubject,
} from './error.constants';
import { ErrorLabels } from './error.labels';
import { SelectorErrors } from './error.types';

/**
 * This class return a react component for the
 * view error. It is used on App.tsx
 */
export class FCalculatorError extends React.Component<
    {
        config: InitialConfiguration;
        error?: string | SelectorErrors;
        vehicleModels?: Array<VehicleModel>;
    },
    { hiddenLegalTermsModal: boolean }
> {
    public appService = new AppService();
    public errorUtilClass = new ErrorUtilClass();
    private brand: string;

    constructor(props) {
        super(props);
        this.state = { hiddenLegalTermsModal: true };

        /**
         * This conditional add the stylesheet only if the brand
         * selected is porsche.
         */
        if (new RegExp(this.props.config.brand, 'i').test(porscheThemeText)) {
            import('../../assets/styles/porsche.styles.scss');
        }

        this.toggleLegalPopUp.bind(this);
        this.redirect.bind(this);

        if (this.props.error && this.props.error !== '') {
            this.alarms(this.props.error);
        }

        this.brand = filters.capitalize(this.props.config.brand);
    }

    /**
     * If the error isn't empty this method will send an alarms-data
     * to the alarms service.
     * @param error string.
     */
    private alarms(error: string | SelectorErrors) {
        if (typeof error === 'string' && error === carDataDoesNotMatch) {
            const matchDataAlarmBody =
                this.errorUtilClass.getVehicleDataAlarmObject(
                    this.props.vehicleModels || [],
                    this.props.config,
                );
            this.appService.fetchMismatchAlarms(matchDataAlarmBody);
        } else if (typeof error !== 'string') {
            this.appService.fetchAlarms({
                subject: changeOrSelectedErrorSubject,
                data: {
                    ...error,
                    brand: this.props.config.brand,
                },
            });
        }
    }

    /**
     * If the error message is change this method call the alarms
     * function to decide if it need to send an alarm or not.
     * @param snapshot
     */
    public componentDidUpdate(snapshot) {
        if (snapshot.error !== this.props.error)
            this.alarms(this.props.error || '');
    }

    /**
     * This method make the redirect to the pre-approval page and
     * close the legal popup.
     */
    private redirect() {
        window.open(
            `https://${this.props.config.brand.toLocaleLowerCase()}.${hrefPreauthorization}`,
            '_blank',
        );
        this.toggleLegalPopUp(true);
    }

    /**
     * This method change the local state to make visible or not
     * the legal popup.
     * @param flag boolean.
     */
    private toggleLegalPopUp(flag: boolean) {
        this.setState({ ...this.state, hiddenLegalTermsModal: flag });
    }

    /**
     * @returns a provisional message to show that occurred
     * an error.
     */
    public render() {
        return (
            <div>
                <div>
                    <h6 className='u-pb-xsmall'>
                        <b>{ErrorLabels.title}</b>
                    </h6>
                    <p>{ErrorLabels.firstText}</p>
                    <p>
                        {ErrorLabels.secondText.replace('{brand}', this.brand)}
                    </p>
                    <div className='o-layout u-pt-xsmall'>
                        <div className='o-layout__item u-1/4 u-1/1@s u-2/6@m'>
                            <div className='o-button-container  o-button-container--right'>
                                <PorscheButton
                                    onClick={() => this.toggleLegalPopUp(false)}
                                    label='Inicia aquí'
                                    id='btnErrorComponent'
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <LegalPopUp
                    brand={this.brand}
                    isHidden={this.state.hiddenLegalTermsModal}
                    onClose={(event) =>
                        event ? this.redirect() : this.toggleLegalPopUp(true)
                    }
                />
            </div>
        );
    }
}
